module.exports = __webpack_public_path__ + "img/Sasha.7d2d459a.jpg";